import styled from 'styled-components';
import { rect, RectProps } from '../../../components/styles';

type Props = RectProps & {
  error?: boolean;
  fill?: boolean;
};

export const Select = styled.select<Props>`
  appearance: none;
  outline: 0;
  padding: ${({ theme }) => `${theme.spaces.m} ${theme.spaces.l}`};
  font-size: ${({ theme }) => theme.fontSizes.m};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.fontColors.default};
  line-height: ${({ theme }) => theme.lineHeights.m};
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='%23223344'><polygon points='0,0 100,0 50,50'/></svg>")
    no-repeat;
  background-position: calc(100% - 8px) calc(50% + 2px);
  background-size: 10px;
  border: 1px solid ${({ theme }) => theme.borderColors.default};
  border-radius: ${({ theme }) => theme.radii.s};

  &:focus {
    border-color: ${({ theme }) => theme.borderColors.primary};
  }

  ${({ fill }) => (fill ? { width: '100%' } : rect)};

  ${({ theme, error }) =>
    error && {
      borderColor: theme.borderColors.error,
      color: theme.fontColors.pink,
      [`&:focus`]: {
        borderColor: theme.borderColors.error,
      },
    }}
`;
